import React, { useEffect, useState } from "react";
import { ScreenHeader } from "react-library";
import { getFarmData, TFarmDataResponse } from "../../services/farm.service";
import {  useParams } from "react-router-dom";
import SpeedoMetersContainer from "../../global-components/SpeedoMetersContainer";
import "./sensors.css";
import dayjs from "dayjs";
import { t } from "../../services/locale.service";

function SensorsScreen() {
  const { plotId, orgId } = useParams();
  //   const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [farmData, setFarmData] = useState<TFarmDataResponse>({});

  const hasInsights = Object.keys(farmData ?? {}).reduce((prev, curr) => {
    return Insights.includes(curr) || prev;
  }, false);

  const fetchFarmData = async () => {
    try {
      setIsLoading(true);
      const farmData = await getFarmData(plotId!);
    
      setFarmData(farmData);
    } catch (error) {
      console.error("error farmdata", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleBack = () => {
    try {
      window.history.back();
    } catch (error) {
      console.log(error);      
    }
  };

  useEffect(() => {
    window.addEventListener("back-icon-press", handleBack);
    return () => {
      window.removeEventListener("back-icon-press", handleBack);
    };
  }, []);

  const hasSensorData = Object.keys(farmData ?? {}).reduce((prev, curr) => {
    return Sensors.includes(curr) || prev;
  }, false);

  useEffect(() => {
    fetchFarmData();
  }, []);

  return (
    <div className="container" style={{ overflowX: "hidden" }}>
      <ScreenHeader screenName={t("Sensor_Stats")} />
      <p style={{
        textAlign: "center",
        color: "gray",
        fontSize: "13px",
      }}>{t("lastUpdated")}: {dayjs(farmData?.timestamp?.description).format("DD MMM YYYY hh:mm A")}</p>
      {
        isLoading ? 
          <p style={{textAlign: "center"}}>{t("Loading")}</p>
          : 
          <>
            {
              hasSensorData ? (
                <SpeedoMetersContainer
                  plotId={plotId!}
                  orgId={orgId}
                  farmData={farmData}
                  speedoMeterFor="sensor"
                />
              ) : <></>
            }
            {hasInsights && (
              <>
                <p className="sectionTitle">{t("Insights")}</p>
                <SpeedoMetersContainer
                  plotId={plotId!}
                  orgId={orgId}
                  farmData={farmData}
                  speedoMeterFor="insight"
                />
              </>
            )}
          </>
      }
    </div>
  );
}

export default SensorsScreen;

export const Sensors = [
  "airHumidity",
  "airPressue",
  "airPressure",
  "airTemp",
  "leafWetness",
  "lightIntensity",
  "rainFall",
  "soilMoisture1",
  "soilMoisture2",
  "moisture1",
  "moisture2",
  "soilTemp",
  "windSpeed",
];

export const Insights = ["deltaT", "VPD"];
